import React, { useEffect, useState } from "react";
import style from "../solo.module.sass";
import CloseSvg from '../../../../../assets/svg/deleteX.svg';
import endSvg from "../../../../../assets/svg/solo/1_end_ico.svg"
import serviceSvg from "../../../../../assets/svg/solo/5_service.svg"
import formSvg from "../../../../../assets/svg/solo/4_form.svg"
import conditionSvg from "../../../../../assets/svg/solo/6_condition.svg"
import AssistedIcon from "../../../../../assets/svg/solo/assistedJourneyGrey.svg"
import webHookIcon from "../../../../../assets/svg/solo/webHook_grey.svg"
import timerSvg from '../../../../../assets/svg/solo/timerIco.svg';
// import ActionSvg from '../../../../../assets/svg/solo/action_selected.svg';
import MessageNodeSvg from '../../../../../assets/svg/solo/message-node.svg';
import LiveAgentNodeSvg from '../../../../../assets/svg/solo/live-agent-node.svg';
import SubflowNodeSvg from '../../../../../assets/svg/solo/subflow-node.svg'
import ReturnNodeSvg from '../../../../../assets/svg/solo/return-node.svg'
import classifierSvg from '../../../../../assets/svg/ai-agents/classifier-black.svg'
import AiAgentsIcon from '../../../../../assets/svg/ai-agents/ai-agents-no-color.svg'
import ActionNodeIcon from '../../../../../assets/svg/solo/actionNodeIcon.svg'

import "./flow.css"
import { useSelector } from "react-redux";

const WidgetListView = (props: any) => {
    const selectedAppType = useSelector(
        (state: any) => state.apps.selectedApp.type
    );
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const positionStyle = {
        top: props.dragVisible
            ? Math.min(props.dragCoordinates.y, window.innerHeight - 450)
            : position.y,
        left: props.dragVisible
            ? Math.min(props.dragCoordinates.x, window.innerWidth - 100)
            : position.x,
        opacity: (props.newNodeDetail || props.dragVisible) ? 1 : 0,
        maxHeight: selectedAppType !== "a8chat" ? 430 : 520
    }
    useEffect(() => {
        if (props.newNodeDetail) {
            const { sourceNode, targetNode, position } = props.newNodeDetail;
            if (sourceNode && targetNode && position) {
                // setPosition({
                //     x: Math.abs(sourceNode.position.x - targetNode.position.x),
                //     y: Math.abs(sourceNode.position.y - targetNode.position.y)
                // })
                let adjustedX = position.x;
                let adjustedY = position.y;

                // Check if position exceeds the screen's bottom or right edge
                if (position.y > window.innerHeight - 150) {
                    adjustedY = window.innerHeight - 450; // Prevent Y overflow
                }
                if (position.x > window.innerWidth - 100) {
                    adjustedX = window.innerWidth - 100; // Prevent X overflow
                }
                setPosition({
                    x: adjustedX,
                    y: adjustedY
                });
            }
        }
    }, [props.newNodeDetail])
    //const [widgetDrawer, setWidgetDrawer]: any = useState(false);
    const [widgetIconHover, setWidgetIconHover]: any = useState(null);
    return (
        <div className={style.list_menu} style={positionStyle}>
            <div>
                <div className={style.header} style={{
                    display: "flex",
                    justifyContent: "space-between",
                    background: "#F7FAFF 0% 0% no-repeat padding-box"
                }}>
                    <label style={{ color: "#0F66C8", margin: "5px 15px", fontSize: 13 }}>
                        Widgets
                    </label>
                    <img alt="closeSvg" src={CloseSvg} onClick={props.onClose} />
                </div>
                <div className={style.items}>
                    {props.icons && props.icons.map((item: any) => {
                        if((item.type === "liveAgent" || item.type === "message") && selectedAppType !== "a8chat") {
                            return null
                        }
                        return item.type !== "start" && item.type !== "error" && item.type !== "event" && !props.showAllNodes ? 
                            <div 
                                onClick={(event) => { props.dragVisible ? props.onDragAddNewNode(item) : props.onAddNewNode(item, props.newNodeDetail.sourceNode, props.newNodeDetail.targetNode, props.newNodeDetail.edge) }}
                                onMouseEnter={() => { setWidgetIconHover(item.type) }}
                                onMouseLeave={() => { setWidgetIconHover(null) }}
                                key={item.type}
                                className={style.item}
                            >
                                <div className={style.icon} style={{ borderColor: item.type === widgetIconHover ? item.color : '#CAD5E9' }}>
                                    {item.type === "stop" && <img alt="icons" src={item.type === widgetIconHover ? item.icon : endSvg} />}
                                    {item.type === "service" && <img alt="icons" src={item.type === widgetIconHover ? item.icon : serviceSvg} />}
                                    {item.type === "form" && <img alt="icons" src={item.type === widgetIconHover ? item.icon : formSvg} />}
                                    {item.type === "condition" && <img alt="icons" src={item.type === widgetIconHover ? item.icon : conditionSvg} />}
                                    {item.type === "assistedJourney" && <img alt="icons" src={item.type === widgetIconHover ? item.icon : AssistedIcon} />}
                                    {item.type === "webhook" && <img alt="icon" src={item.type === widgetIconHover ? item.icon : webHookIcon} />}
                                    {item.type === "timer" && <img alt="icon" src={item.type === widgetIconHover ? item.icon : timerSvg} />}
                                    {item.type === "message" && <img alt="icon" src={item.type === widgetIconHover ? item.icon : MessageNodeSvg} />}
                                    {item.type === "liveAgent" && <img alt="icon" src={item.type === widgetIconHover ? item.icon : LiveAgentNodeSvg} />}
                                    {item.type === "subflow" && <img alt="icon" src={item.type === widgetIconHover ? item.icon : SubflowNodeSvg} />}
                                    {item.type === "return" && <img alt="icon" src={item.type === widgetIconHover ? item.icon : ReturnNodeSvg} />}
                                    {item.type === "aiAgent" && <img alt="icon" src={item.type === widgetIconHover ? item.icon : AiAgentsIcon} />}
                                    {item.type === "aiClassifier" && <img alt="icon" src={item.type === widgetIconHover ? item.icon : classifierSvg} />}
                                    {item.type === "action" && <img alt="icon" src={item.type === widgetIconHover ? item.icon : ActionNodeIcon} />}
                                </div>
                                <div className={style.title} style={{ color: item.type === widgetIconHover ? item.color : '#657695' }}>
                                    {item.label}
                                </div>
                            </div> : 
                            item.type === "service" &&
                            <div
                                onClick={(event) => { props.dragVisible ? props.onDragAddNewNode(item) : props.onAddNewNode(item, props.newNodeDetail.sourceNode, props.newNodeDetail.targetNode, props.newNodeDetail.edge) }}
                                onMouseEnter={() => { setWidgetIconHover(item.type) }}
                                onMouseLeave={() => { setWidgetIconHover(null) }}
                                key={item.type}
                                className={style.item}
                            >
                                <div className={style.icon} style={{ borderColor: item.type === widgetIconHover ? item.color : '#CAD5E9' }}>
                                        {item.type === "service" && <img alt="icons" src={item.type === widgetIconHover ? item.icon : serviceSvg} />}
                                </div>
                                <div className={style.title} style={{ color: item.type === widgetIconHover ? item.color : '#657695' }}>
                                        {item.label}
                                </div>
                            </div>
                    })}
                </div>
            </div>
        </div>
    );
}

export default WidgetListView;